import * as React from 'react';
import { Action } from 'redux';

import { WelcomeScreenStyles } from '../styles/WelcomeScreenStyles';
import { WelcomeScreenActions, WelcomeScreenLinkDetails } from '../utils/WelcomeScreenLinks';
import { WelcomeScreenActionTypes, WelcomeScreenTestIds } from './WelcomeScreen';

/**
 * Welcome Screen List of Links Component
 */

type SendTelemetryEvent = (actionType: WelcomeScreenActionTypes, action: WelcomeScreenActions) => void;

interface WelcomeScreenLinkListProps {
  links: WelcomeScreenLinkDetails[];
  dispatchAction: (action: Action) => void;
  sendTelemetryEvent: SendTelemetryEvent;
}

export class WelcomeScreenLinkList extends React.PureComponent<WelcomeScreenLinkListProps> {
  render() {
    return (
      <p className={WelcomeScreenStyles.links}>
        {this.props.links.map((link, index) => (
          <WelcomeScreenLink
            key={index}
            actionName={link.actionName}
            dispatchAction={this.props.dispatchAction}
            sendTelemetryEvent={this.props.sendTelemetryEvent}
            getAction={link.getAction}
            linkTitle={link.linkTitle}
            openNewTab={link.openNewTab}
            position={index}
            url={link.url}
          />
        ))}
      </p>
    );
  }
}

/**
 * Welcome Screen Link Component
 */

export interface WelcomeScreenLinkProps extends WelcomeScreenLinkDetails {
  actionName: WelcomeScreenActions;
  position: number;
  dispatchAction: (action: Action) => any;
  sendTelemetryEvent: SendTelemetryEvent;
}

export class WelcomeScreenLink extends React.PureComponent<WelcomeScreenLinkProps> {

  private handleAction() {
    this.props.sendTelemetryEvent(WelcomeScreenActionTypes.secondary, this.props.actionName);

    if (this.props.getAction) {
      this.props.dispatchAction(this.props.getAction());
    }
  }

  render() {
    return (
      <>
        {this.props.position !== 0 && <span className={WelcomeScreenStyles.linkDivider}>|</span>}
        <a className={WelcomeScreenStyles.link}
          href={this.props.url}
          target={this.props.openNewTab ? '_blank' : '_self'}
          onClick={() => this.handleAction()}
          data-tb-test-id={WelcomeScreenTestIds.welcomeScreenLink}
        >
          {this.props.linkTitle}
        </a>
      </>
    );
  }
}
